import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './Vehicle.css';
import VehicleForm from './VehicleForm';
import Conect from '../../services/api/Conect';

const Vehicles = () => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [search, setSearch] = useState('');

  const fetchVehicles = useCallback(async () => {
    const token = localStorage.getItem('fptoken');
    setLoading(true);
    setError(null);
    try {
      const { data } = await Conect.get(`/listallvehicles${token}`);
      setVehicles(data.data ?? []);
    } catch (err) {
      console.error('Erro ao buscar veículos:', err);
      setError('Não foi possível carregar os veículos.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const handleOpenModal = useCallback((vehicle = null) => {
    setEditData(vehicle);
    setModalOpen(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setModalOpen(false);
    setEditData(null);
  }, []);

  const filteredVehicles = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return vehicles;
    return vehicles.filter(v =>
      v.plate?.toLowerCase().includes(q) ||
      v.brand_name?.toLowerCase().includes(q) ||
      v.model_name?.toLowerCase().includes(q) ||
      v.type?.toLowerCase().includes(q)
    );
  }, [vehicles, search]);

  return (
    <div className="v-container">
      <div className="v-header">
        <h2>Veículos Cadastrados</h2>
        <div className="v-actions-header">
          <input
            type="text"
            placeholder="Buscar por placa, marca, modelo ou tipo"
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="v-search"
          />
          <button className="v-add-btn" onClick={() => handleOpenModal()}>
            + Novo Veículo
          </button>
        </div>
      </div>

      <div className="v-list">
        {error ? (
          <div className="v-state-msg">
            <span>{error}</span>
            <button className="v-retry-btn" onClick={fetchVehicles}>Tentar novamente</button>
          </div>
        ) : loading ? (
          <table className="v-table">
            <thead>
              <tr>
                {['#','Placa','Marca','Modelo','Ano','Tipo','Descrição','Ações'].map(h => (
                  <th key={h}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {Array.from({ length: 5 }).map((_, i) => (
                <tr key={i} className="v-skeleton-row">
                  {Array.from({ length: 8 }).map((_, j) => (
                    <td key={j}><span className="v-skeleton" /></td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <table className="v-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Placa</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Ano</th>
                <th>Tipo</th>
                <th>Descrição</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {filteredVehicles.length > 0 ? (
                filteredVehicles.map((vehicle, index) => (
                  <tr key={vehicle.id}>
                    <td>{index + 1}</td>
                    <td><span className="v-plate">{vehicle.plate}</span></td>
                    <td>{vehicle.brand_name}</td>
                    <td>{vehicle.model_name}</td>
                    <td>{vehicle.year}</td>
                    <td>
                      <span className={`v-badge v-badge--${vehicle.type === 'SEMI-REBOQUE' ? 'alt' : 'default'}`}>
                        {vehicle.type}
                      </span>
                    </td>
                    <td className="v-desc">{vehicle.description || '—'}</td>
                    <td>
                      <button
                        onClick={() => handleOpenModal(vehicle)}
                        className="v-edit-btn"
                      >
                        Editar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="8" className="v-empty">
                    {search ? `Nenhum resultado para "${search}"` : 'Nenhum veículo cadastrado'}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {modalOpen && (
        <div className="v-modal-overlay" onClick={e => e.target === e.currentTarget && handleCloseModal()}>
          <div className="v-modal">
            <VehicleForm
              vehicles={vehicles}
              vehicle={editData}
              onClose={handleCloseModal}
              onRefresh={fetchVehicles}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Vehicles;